import React from 'react';
import { DateTimeFormatProvider } from '@utmost.co/utmost-design-system/src/utils/DateTimeFormatProvider';
import { OptionTypeWithCode as UtmostOptionTypeWithCode } from '@utmost.co/utmost-design-system/src/components';
import { DateTimeFormatProvider as BpDateTimeFormatProvider } from '@beeline.com/bp-design-system';
import { useLoggedInUser } from 'src/utils/hooks/useLoggedInUser';
import { useTenantConfig } from 'src/utils/hooks/useTenantConfig';
import { useTimezones } from 'src/utils/hooks/useTimezones';

export const OcDateTimeFormatProvider: React.FC<React.PropsWithChildren<{ timezones?: string[] }>> = ({
  children,
  timezones
}) => {
  const loggedInUser = useLoggedInUser();
  const tenant = useTenantConfig();
  const { loading, timezoneOptions } = useTimezones(timezones);
  const config = loggedInUser?.preferences?.dateTimeFormatConfig ?? tenant?.dateTimeFormatConfig;
  return (
    <BpDateTimeFormatProvider
      dateTimeFormatConfig={
        config
          ? {
              ...config,
              dateOrder: config?.format ?? 'YEAR_MONTH_DAY'
            }
          : undefined
      }
      loadingTimezones={loading}
      timezoneOptions={timezoneOptions}
    >
      <DateTimeFormatProvider
        dateTimeFormatConfig={config}
        loadingTimezones={loading}
        // bp's OptionTypeWithCode.secondarySubLabel is React.ReactNode; the legacy utmost provider
        // types it as string. Timezone options never set that field, so the cast is safe.
        timezoneOptions={timezoneOptions as UtmostOptionTypeWithCode<string>[]}
      >
        {children}
      </DateTimeFormatProvider>
    </BpDateTimeFormatProvider>
  );
};
